import { useEffect, useState } from 'react';
import apiClient from 'src/api/apiClient';

const cache = new Map();

export const useAvatar = (clave) => {
  const [src, setSrc] = useState('');

  useEffect(() => {
    if (!clave) {
      setSrc('');
      return;
    }
    if (cache.has(clave)) {
      setSrc(cache.get(clave));
      return;
    }
    let cancelado = false;
    apiClient
      .get(`/user/avatar/${encodeURIComponent(clave)}`, { responseType: 'blob' })
      .then((response) => {
        const url = URL.createObjectURL(response.data);
        cache.set(clave, url);
        if (!cancelado) setSrc(url);
      })
      .catch(() => {
        if (!cancelado) setSrc('');
      });
    return () => {
      cancelado = true;
    };
  }, [clave]);

  return src;
};
